const form = {
  formId: "new-user-form",
  formField: {
    checkbox1: {
      name: "checkbox1",
      label:
        "Cá nhân cho thuê tài sản trực tiếp khai thuế / Tổ chức, cá nhân khai thuế thay, nộp thuế thay cho cá nhân ủy quyền theo quy định của pháp luật dân sự: ",
      type: "text",
    },
    checkbox2: {
      name: "checkbox2",
      label: "Doanh nghiệp, tổ chức kinh tế khai thuế thay, nộp thuế thay theo pháp luật thuế",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    field01a: {
      name: "field01a",
      label: "[01a] Năm",
      type: "number",
      placeholder: "2023",
      errorMsg: "Vui lòng nhập năm",
    },
    field01b: {
      name: "field01b",
      label: "[01b] Kỳ thanh toán",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01c: {
      name: "field01c",
      label: "[01c] Tháng / năm",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    field01d: {
      name: "field01d",
      label: "[01d] Từ tháng / Đến tháng",
      type: "number",
      errorMsg: "Vui lòng chọn kỳ thanh toán",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    contractCode: {
      name: "contractCode",
      label: "Mã hợp đồng",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập mã hợp đồng",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contactAddress: {
      name: "contactAddress",
      label: "[06] Địa chỉ liên hệ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ liên hệ",
    },
    province: {
      name: "province",
      label: "[06.3] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    district: {
      name: "district",
      label: "[06.2] Quận/Huyện/Thị xã/Tp thuộc tỉnh ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    ward: {
      name: "ward",
      label: "[06.1] Số nhà, đường phố/xóm/ấp/thôn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tỉnh / thành phố",
    },
    phone: {
      name: "phone",
      label: "[07] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[08] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[09] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    identity: {
      name: "identity",
      label: "[10] Số CMND/CCCD (trường hợp cá nhân quốc tịch Việt Nam)",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    passport: {
      name: "passport",
      label: "[11] Hộ chiếu (trường hợp cá nhân không có quốc tịch Việt Nam)",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[13] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[14] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contract: {
      name: "contract",
      label: "[08] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
    },
    contractDate: {
      name: "contractDate",
      label: "Ngày",
      type: "number",
    },
    organizationName: {
      name: "organizationName",
      label: "[16] Tổ chức khai, nộp thuế thay (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxId2: {
      name: "taxId2",
      label: "[17] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[18] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    phone2: {
      name: "phone2",
      label: "[19] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax2: {
      name: "fax2",
      label: "[20] Fax:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email2: {
      name: "email2",
      label: "[21] Email:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    authDocument: {
      name: "authDocument",
      label: "[21] Văn bản ủy quyền (nếu có):",
      type: "text",
      placeholder: "",
    },
    authDocumentDate: {
      name: "authDocumentDate",
      label: "Ngày",
      type: "number",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
